import { Sine, TimelineLite } from "gsap";
import { Application } from "../Application";
import { AppProgress } from "../Data/AppProgress";
import { GalleryPaintableData } from "../Data/GalleryPaintableData";
import { GameType } from "../Data/GameData";
import { GalleryItem } from "../GameObjects/GalleryItem";
import { Paintable } from "../GameObjects/Paintable";

export abstract class GalleryPaintable extends GalleryItem {
    protected _paintable: Paintable | undefined;

    constructor(pGameType: GameType, pCallback: (pItem: GalleryItem) => void) {
        super(pGameType, pCallback);
    }

    protected get recentIndex(): number {
        return AppProgress.games[this._gameType].recentItemIndex;
    }

    protected get saveData(): GalleryPaintableData {
        return AppProgress.games[this._gameType].saveData[this.recentIndex] as GalleryPaintableData;
    }

    public presentItem(): TimelineLite {
        this.interactive = false;
        this._paintable!.scale.set(this._presentScale);

        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._visuals!, 1.0, {
            x: 0,
            y: -100,
            ease: Sine.easeInOut,
        });
        return timeline;
    }

    public animateItem(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this.saveData.sequence.length; i++) {
            const index = i;
            timeline.call(() => {
                this._paintable!.paintLayer(
                    this.saveData.sequence[index],
                    this.saveData.colours[this.saveData.sequence[index]],
                    false,
                );
            }, undefined, this, i * 0.2);
        }
        return timeline;
    }

    public moveItemToWall(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._visuals, 1.0, {
            x: this._homePos.x,
            y: this._homePos.y,
            ease: Sine.easeInOut,
        }, 0);
        timeline.to(this._paintable!.scale, 1.0, {
            x: this._homeScale,
            y: this._homeScale,
            ease: Sine.easeInOut,
        }, 0);
        return timeline;
    }

    public cacheVisuals(): PIXI.Texture {
        const scale: number = this._paintable!.scale.x;
        this._paintable!.scale.set(1);
        const texture: PIXI.Texture = Application.instance.renderer.generateTexture(
            this._visuals,
            undefined,
            Application.instance.renderer.resolution,
        );
        this._paintable!.scale.set(scale);
        return texture;
    }
}
